// extracted by mini-css-extract-plugin
export default {"main":"main__HY1Fn","subtitle":"subtitle__R2GPT"};